import { useContext } from 'react';
import { SettingsTaskContext } from './SettingsTaskContext.base';

export function useSettingsTaskCount(): number {
  return useContext(SettingsTaskContext).taskCount;
}

export function useSettingsTaskLoaded(): boolean {
  return useContext(SettingsTaskContext).hasLoaded;
}

export function useSetSettingsTaskCount(): (count: number) => void {
  return useContext(SettingsTaskContext).setTaskCount;
}
